import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { installStartupDiagnostics } from "./lib/startup-diagnostics";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  installStartupDiagnostics();
  console.info("[GAMO_DIAG] getRouter start");
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  console.info("[GAMO_DIAG] getRouter end", { scrollRestoration: true });
  return router;
};
